import React, { useContext } from 'react'
import { StateContext } from '../services/StateService'
import { Translations } from '../services/TranslationService'
import { trackPDPData } from '../services/TealiumService'
import { PDP_DISCLAIMER_ID } from '../constants/PDPConstants'
import scrollService from '../services/ScrollService'
import '../css/DisclaimerLinks.scss'

export const DisclaimerLinks = () => {
    const { disclaimerInfo } = useContext(StateContext)
    const translations = useContext(Translations)
    return (
        <>
            {disclaimerInfo?.disclaimer && (
                <button
                    className="sps2-pdp_no-style-btn sps2-pdp_disclaimer--link mds-link_primary"
                    onClick={() => {
                        scrollService.scrollToSection(PDP_DISCLAIMER_ID)
                        trackPDPData(
                            `PDP Buying Zone Disclaimer Link Click: ${translations.viewLegalDisclaimer}`,
                            'Engagement Event'
                        )
                    }}
                >
                    {translations.viewLegalDisclaimer}
                </button>
            )}
            {disclaimerInfo?.extendedIntendedUseDisclaimer && (
                <button
                    className="sps2-pdp_no-style-btn sps2-pdp_disclaimer--link mds-link_primary"
                    onClick={() => {
                        scrollService.scrollToSection(PDP_DISCLAIMER_ID)
                        trackPDPData(
                            `PDP Buying Zone Disclaimer Link Click: ${disclaimerInfo?.intendedUseDisclaimer}`,
                            'Engagement Event'
                        )
                    }}
                >
                    {disclaimerInfo?.intendedUseDisclaimer}
                </button>
            )}
        </>
    )
}

export default DisclaimerLinks
